export default `float i,g,e=1.,s,l;
    p.z-=9.; s=2.;
    p=abs(p);
    for(int j=0;j++<6;)
      p=-sign(p)*(abs(abs(abs(p)-2.)-1.)-1.),
      p*=l=-2./max(.3,sqrt(min(min(p.x,p.y),p.z))),
      p-=2., s*=l;
    return length(p)/s;
  }`